// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyDeliveryMethodWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyDeliveryMethodResponseWebDto } from '../..';

interface DeliveryMethodParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Path =
  '/api/web/v1/users/properties/deliveryMethod';

/**
 * Get delivery method of a property
 */
export const RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod = (
  getParams: DeliveryMethodParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeliveryMethodParams, never, UserPropertyDeliveryMethodResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyDeliveryMethodWebApiHandler_deliveryMethod_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
